import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { VariesByCatalogService } from "../services/varies-by-catalog-service";
import { DateCalcService } from "../services/date-calc-service";


export function RLQuickRightsEntry() {
        var directive: ng.IDirective = {
            restrict: "AE",
            template: require("/assets/app/templates/quick-rights-entry.html"),
            controller: RLQuickRightsEntryController,
            controllerAs: "qreVM",
            bindToController: true,
            scope: {
                openModal: "=",
                templateID: "=templateId",
                parentEntityID: "=parentEntityId",
                charDataCollection: "=",
                selectedAssets: "=",
				selectedContacts: "=?",
                goBack: "=",
                forceRefresh: "=",
                newRightsIDs: "=?newRightsIds"
            }
        };

        return directive;
    }

    class RLQuickRightsEntryController {
		static $inject = ["$scope", "$rootScope", "$q", "$window", "$filter", "notifyService", "entityService", "eventService", "variesByCatalogService", "dateCalcService"];

        openModal: boolean;
        templateID: string;
        parentEntityID: string;
        charDataCollection: Models.ICharDataCollection;
        selectedAssets: { [key: string]: string };
        goBack: boolean;
        forceRefresh: boolean;
        newRightsIDs: string[];

        fields: string[];
        collapseRights: boolean;
        rightsOption: string;

        catalogCharDataExclusiveCollection: { [key: number]: Models.ICharDataCollection };
        catalogCharDataNonExclusiveCollection: { [key: number]: Models.ICharDataCollection };

        invalidAssetRows: { [key: number]: boolean };
        validAssetRows: { [key: number]: boolean };
        formInvalid: boolean;

        validateOnCreate: boolean;
        invalidAssets: string[];
        invalidAssetsCount: number;

        newRightsIDsList: string;
        selectedAssetsSorted: Models.IKeyValuePair<string, string>[];

        //Holdbacks do not have exclusivity, so we need to hide the Exclusive Column
        hideExclusiveColumn: boolean;

        //Job
        showJobProgressStatus: boolean;
        jobId: string;
        jobTitle: string;
        jobTemplateID: number;
        progressStatus: string;
        //--

        //Bulk Edit
        bulkEditColumn: boolean;
        bulkEditCharData: Models.ICharDataValue[];
        bulkEditField: string;
        bulkEditExclusive: boolean;

		//Relative To Catalog
		selectedCharDataCollections: Models.ICharDataCollection[];
		commonCMDs: Models.ICharacteristicMetaData[];
		firstCatalogItem: number;
		firstCatalogItemCharDataCol: Models.ICharDataCollection;
		isCorrectingRelativeDateMath: boolean;
        //--
        visibility: number;
		selectedContacts: string[];

        constructor(
			private $scope: ng.IScope,
			private $rootScope: ng.IRootScopeService,
            private $q: ng.IQService,
            private $window: ng.IWindowService,
            private $filter: ng.IFilterService,
            private notifyService: NotifyService,
            private entityService: EntityService,
            private eventService: EventService,
            private variesByCatalogService: VariesByCatalogService,
            private dateCalcService: DateCalcService) {

            this.collapseRights = true;
            this.rightsOption = "collapse";
            this.invalidAssetRows = {};
            this.validAssetRows = {};
            this.formInvalid = true;
            this.validateOnCreate = false;
            this.bulkEditColumn = false;
            this.bulkEditCharData = [];
            this.bulkEditExclusive = true;
            this.hideExclusiveColumn = false;
            this.visibility = 1;

            $scope.$watch(() => this.selectedAssets, (newValue, oldValue) => {
                if (newValue != oldValue && _.keys(newValue).length > 0) {
                    this.validAssetRows = {};
                    this.invalidAssetRows = {};
                    this.formInvalid = true;

                    //Check to see how many catalog items are available and change the validation approach as necessary
                    if (_.keys(this.selectedAssets).length > 40) {
                        //If we have more than 40 catalog items, then we want to validate the data on Create, not real-time
                        this.validateOnCreate = true;

                        for (var assetID in this.selectedAssets) {
                            this.validAssetRows[assetID] = true;
                        }

                        this.formInvalid = false;
                    }
                    else {
                        this.validateOnCreate = false;

                        for (var assetID in this.selectedAssets) {
                            this.validAssetRows[assetID] = false;
                        }
                    }

                    //We create a sorted collection for display purposes only
                    this.selectedAssetsSorted = [];
                    _.keys(this.selectedAssets).forEach(key => {
                        var value = this.selectedAssets[key];
                        this.selectedAssetsSorted.push({ key: key, value: value });
                    });

                    var split = Utils.IdBuilder.splitEntityID(this.parentEntityID);

                    //If the keys are a full entity ID, parse them out firs
                    var keys = _.keys(this.selectedAssets).map(x => Utils.IdBuilder.isEntityID(x) ? Utils.IdBuilder.splitEntityID(x).recID : _.parseInt(x));

					this.entityService.getEntityCharDatas(split.divID, 1, keys).then(selectedCharDataCollections => {
						this.selectedCharDataCollections = selectedCharDataCollections;
						this.GetCommonCmds();
						this.firstCatalogItem = keys[0];
						this.firstCatalogItemCharDataCol = this.selectedCharDataCollections[0];
					});
                }
            }, true);

            $scope.$watch(() => this.openModal, (newValue, oldValue) => {
                if (newValue) {
                    this.fields = [];
                    this.catalogCharDataExclusiveCollection = {};
                    this.catalogCharDataNonExclusiveCollection = {};
                    this.invalidAssets = [];
                    this.invalidAssetsCount = 0;

                    var hasTermStartDate = false;
                    var hasTermEndDate = false;

                    for (var field in this.variesByCatalogService.selectedFields) {
                        if (this.variesByCatalogService.selectedFields[field]) {
                            this.fields.push(field);

                            if (field == "actual_term_start") {
                                hasTermStartDate = true;
                            }

                            if (field == "actual_term_end") {
                                hasTermEndDate = true;
                            }
                        }
                    }

                    //Reverse the order of the fields, since we want Term Start to always come first
                    this.fields = this.fields.sort().reverse();

                    if (this.variesByCatalogService.selectedDimension != '') {
                        this.fields.push(this.variesByCatalogService.selectedDimension);
                    }

                    //Does the charDataCollection have an exclusivity field? Some do not, like Holdbacks.  We need to hide the Exclusive column if so
                    if (this.charDataCollection.charDatas["exclusivity"] == null || (this.charDataCollection.charDatas["exclusivity"] && this.charDataCollection.charDatas["exclusivity"].length == 0)) {
                        this.hideExclusiveColumn = true;
                    }
                    else {
                        this.hideExclusiveColumn = false;
                    }

                    for (var assetID in this.selectedAssets) {
                        this.catalogCharDataExclusiveCollection[assetID] = _.cloneDeep(this.charDataCollection);
                        this.catalogCharDataNonExclusiveCollection[assetID] = _.cloneDeep(this.charDataCollection);

                        //Clear out any "default" dates in the non-exclusive collection
                        //unless we don't have exclusivity, in which case, keep them.
                        if (!this.hideExclusiveColumn) {
                            if (hasTermStartDate) {
                                this.catalogCharDataNonExclusiveCollection[assetID].charDatas["actual_term_start"][0].value = null;
                            }

                            if (hasTermEndDate) {
                                this.catalogCharDataNonExclusiveCollection[assetID].charDatas["actual_term_end"][0].value = null;
                            }
                        }
                    }
                }
            });

            $scope.$watch(() => this.rightsOption, (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (this.rightsOption === "collapse") {
                        this.collapseRights = true;
                    }
                    else {
                        this.collapseRights = false;
                    }
                }
            }, true);

            $scope.$watch(() => this.invalidAssetRows, (newValue, oldValue) => {
                this.invalidAssetsCount = _.values(this.invalidAssetRows).filter(v => v === true).length;

                if (newValue != oldValue && !this.validateOnCreate) {
                    this.formInvalid = this.invalidAssetsCount > 0;
                }

            }, true);

            $scope.$watch(() => this.catalogCharDataExclusiveCollection, (newValue, oldValue) => {
                if (newValue != oldValue && !this.validateOnCreate) {
                    for (var assetID in this.selectedAssets) {
                        this.IsSetInvalid(assetID);
                    }
                }
            }, true);

            $scope.$watch(() => this.catalogCharDataNonExclusiveCollection, (newValue, oldValue) => {
                if (newValue != oldValue && !this.validateOnCreate) {
                    for (var assetID in this.selectedAssets) {
                        this.IsSetInvalid(assetID);
                    }
                }
            }, true);
        }

        PreCreateRight() {
            if (this.validateOnCreate) {
                if (this.ValidateOnCreate()) {
                    this.CreateRight();
                }
            }
            else {
                this.CreateRight();
            }

        }

        CreateRight() {
            this.notifyService.startProgress();

            var exclusiveCollection: { [key: number]: Models.ICharDatas } = {};
            var nonExclusiveCollection: { [key: number]: Models.ICharDatas } = {};

            var promises: ng.IPromise<any>[] = [];

            for (var assetID in this.selectedAssets) {
                //Exclusive
                var exclusiveCol = this.catalogCharDataExclusiveCollection[assetID];

                if (!this.hideExclusiveColumn) {
                    //Make sure the exclusive field is set to exclusive
                    exclusiveCol.charDatas["exclusivity"][0].value = "Exclusive";
                    exclusiveCol.charDatas["exclusivity"][0].valueID = 1;
                }

                if (this.CollectionChanged(exclusiveCol)) {
                    exclusiveCollection[assetID] = exclusiveCol.charDatas;
                }

                //Non-Exclusive
                var nonExclusiveCol = this.catalogCharDataNonExclusiveCollection[assetID];

                if (!this.hideExclusiveColumn) {
                    //Make sure the exclusive field is set to non-exclusive
                    nonExclusiveCol.charDatas["exclusivity"][0].value = "Non-Exclusive";
                    nonExclusiveCol.charDatas["exclusivity"][0].valueID = 2;
                }

                if (this.CollectionChanged(nonExclusiveCol)) {
                    nonExclusiveCollection[assetID] = nonExclusiveCol.charDatas;
                }
            }

            this.$q.all(promises)
                .then(() => {
                    //If we're creating Rights from a Catalog Item, use CreateEntity since we're processing only 1 entity and the logic
                    //is different
					var childCharTypeIDs: number[] = [];

                    if (_.keys(this.selectedAssets).length == 1 && this.parentEntityID == assetID) {
						childCharTypeIDs.push(Consts.CharTypeIDs.user);
                        var promises: ng.IPromise<any>[] = [];
                        var newRightsIDs: string[] = [];
						var childEntityIDs = this.selectedContacts;

                        if (_.keys(exclusiveCollection).length > 0) {
							promises.push(this.entityService.createEntityWithOptions(this.templateID, this.parentEntityID, exclusiveCollection[assetID], childCharTypeIDs, childEntityIDs)
                                .then((result) => {
                                    newRightsIDs.push(result.entityID);
                                }));
                        }

                        if (_.keys(nonExclusiveCollection).length > 0) {
							promises.push(this.entityService.createEntityWithOptions(this.templateID, this.parentEntityID, nonExclusiveCollection[assetID], childCharTypeIDs, childEntityIDs)
                                .then((result) => {
                                    newRightsIDs.push(result.entityID);
                                }));
                        }

                        this.$q.all(promises)
                            .then(() => {
                                this.newRightsIDs = newRightsIDs;
                                this.openModal = false;
                                this.notifyService.notifySuccess("Rights Created");
                            })
                            .finally(() => {
                                this.variesByCatalogService.clearSavedFields();
                                this.notifyService.endProgress();
                            });
                    } else {

						childCharTypeIDs.push(Consts.CharTypeIDs.property);
						childCharTypeIDs.push(Consts.CharTypeIDs.user);
						var contactEntityIDs = this.selectedContacts;

                        this.variesByCatalogService.createVariedRights(this.fields,
                                this.collapseRights,
                                this.parentEntityID,
                                this.templateID,
                                exclusiveCollection,
								nonExclusiveCollection,
								contactEntityIDs)
                            .then((result) => {
                                this.openModal = false;
                                this.showJobProgressStatus = true;
                                this.jobId = result.jobID;
                                this.jobTitle = result.jobTitle;
                                this.jobTemplateID = Utils.IdBuilder.splitTemplateID(this.templateID).templateID;
                            })
                            .finally(() => {
                                this.variesByCatalogService.clearSavedFields();
                                this.notifyService.endProgress();
                            });
                    }
                });
        }

        ValidateOnCreate(): boolean {
            var isValid: boolean = false;
            this.invalidAssets = [];

            this.notifyService.startProgress();

            for (var i = 0; i < _.keys(this.selectedAssets).length; i++) {
                var assetID = _.keys(this.selectedAssets)[i];

                if (this.IsSetInvalid(assetID)) {
                    this.invalidAssets.push(this.selectedAssets[assetID]);
                    isValid = false;
                }
            }

            if (this.invalidAssets.length == 0) {
                isValid = true;
            }

            //Always make sure the Create button is enabled since we're validating on the button click
            this.formInvalid = false;

            this.notifyService.endProgress();
            return isValid;
        }

        PostRightsCreation(newRightsIDsList: any) {
            //Return the newly created set of Rights
            this.newRightsIDs = Utils.JsonUtil.Parse(newRightsIDsList, {});
			this.forceRefresh = true;
			this.$rootScope.$broadcast(Consts.Events.RefreshDealDetails, this.parentEntityID);
        }

        CollectionChanged(collection: Models.ICharDataCollection): boolean {
            var hasChanged = false;
            var oldValue = "";
            var newValue = "";

            this.fields.forEach(field => {
                //Get the original value
                if (this.charDataCollection.charDatas[field].length > 0) {
                    var oldChar = this.charDataCollection.charDatas[field][0];
                    oldValue = oldChar.value || JSON.stringify(oldChar.ext);
                }

                //Get the new value
                if (collection.charDatas[field].length > 0) {
                    var newChar = collection.charDatas[field][0];
                    newValue = newChar.value || JSON.stringify(newChar.ext);
                }

                if (oldValue != newValue && !_.isEmpty(newValue)) {
                    hasChanged = true;
                }
                else if (oldValue == newValue && !_.isEmpty(newValue)) {
                    //We need this in case the user provides a "default"/starter value from the Create Rights page to prepopulate the quick rights
                    hasChanged = true;
                }
            });

            return hasChanged;
        }

        IsSetInvalid(assetID: string): boolean {
            var isInvalid: boolean = true;
            var exclusiveFields: { [key: string]: boolean } = {};
            var nonExclusiveFields: { [key: string]: boolean } = {};

            //Make sure the dictionary is populated prior to evaluation
            if (_.keys(this.catalogCharDataExclusiveCollection).length > 0) {
                this.fields.forEach(field => {
                    //Get the Exclusive values
                    if (this.catalogCharDataExclusiveCollection[assetID].charDatas[field].length > 0) {
                        var charData = this.catalogCharDataExclusiveCollection[assetID].charDatas[field][0];
                        var value = charData.value || charData.ext;

                        var isEmpty = true;

                        if (!_.isNull(value) && !_.isEmpty(value)) {
                            isEmpty = false;
                        }

                        exclusiveFields[field] = isEmpty;
                    }
                    else {
                        exclusiveFields[field] = true;
                    }

                    //Get the Non-Exclusive values
                    if (this.catalogCharDataNonExclusiveCollection[assetID].charDatas[field].length > 0) {
                        var charData = this.catalogCharDataNonExclusiveCollection[assetID].charDatas[field][0];
                        var value = charData.value || charData.ext;

                        var isEmpty = true;

                        if (!_.isNull(value) && !_.isEmpty(value)) {
                            isEmpty = false;
                        }

                        nonExclusiveFields[field] = isEmpty;
                    }
                    else {
                        nonExclusiveFields[field] = true;
                    }
                });

                //Check the collections.  We need either Exclusive or Non-Exclusive to have a complete "set", or BOTH.
                var exclusiveInvalid = false;
                var nonExclusiveInvalid = false;

                var invalidExclusiveFieldsCount = _.values(exclusiveFields).filter(v => v === true).length;

                if (invalidExclusiveFieldsCount > 0 && invalidExclusiveFieldsCount < this.fields.length) {
                    exclusiveInvalid = true;
                }

                var invalidNonExclusiveFieldsCount = _.values(nonExclusiveFields).filter(v => v === true).length;

                if (invalidNonExclusiveFieldsCount > 0 && invalidNonExclusiveFieldsCount < this.fields.length) {
                    nonExclusiveInvalid = true;
                }

                //If we're hiding the Exclusive column, then check only the non-exclusive side
                if (this.hideExclusiveColumn && !nonExclusiveInvalid) {
                    isInvalid = false;
                }
                //If isInvalid is true at this point, it means we have an incomplete set on one side
                //so all remaining fields should still be required
                else if (exclusiveInvalid || nonExclusiveInvalid) {
                    isInvalid = true;
                }
                else if (invalidExclusiveFieldsCount == this.fields.length && invalidNonExclusiveFieldsCount == this.fields.length) {
                    //Both sets are empty and all fields should still be required
                    isInvalid = true;
                }
                else if ((exclusiveInvalid && !nonExclusiveInvalid) || (!exclusiveInvalid && nonExclusiveInvalid)) {
                    //If one set is empty while the other is complete, then return false since the other set is now optional
                    isInvalid = false;
                }
                else {
                    //Both sets are filled in and all is valid
                    isInvalid = false;
                }
            }

            this.invalidAssetRows[assetID] = isInvalid;

            if (!this.validateOnCreate) {
                this.validAssetRows[assetID] = !isInvalid;
            }

            return isInvalid;
        }

        GoBack() {
            this.openModal = false;
            this.goBack = true;
        }

        Cancel() {
            this.selectedAssets = {};
            this.openModal = false;
            this.variesByCatalogService.clearSavedFields();
        }

        GetColumn(fieldName): Models.ICharacteristicMetaData {
            var emptyField: Models.ICharacteristicMetaData = {
                characteristicID: null,
                charTypeID: null,
                charValueSetID: "",
                charValueSourceID: "",
                dataTypeID: null,
                groupID: null,
                label: "",
                maxLength: null,
                multipleIndicator: null,
                requiredIndicator: null,
                sequenceNumber: null,
                systemIndicator: null,
                tagLabel: "",
                acl: "",
				reportIndicator: null,
                description: "",
                triggerTypeID: null,
                triggerCharID: null,
                triggerValue: null
            };

            if (fieldName != null) {
                var field = this.charDataCollection.templateMetaData.characteristicMetaDatas.filter(c => c.tagLabel == fieldName);

                if (!_.isNull(field) && field.length > 0) {
                    return field[0];
                }
                else {
                    return emptyField;
                }
            }
        }

        //Bulk Edit
        BulkEditColumn(fieldName: string, isExclusive: boolean = false) {
            this.bulkEditColumn = true;

            this.bulkEditExclusive = isExclusive;

            this.bulkEditField = fieldName;

            var firstAssetKey = _.first(_.keys(this.selectedAssets));
            var fieldCharData = null;

            if (isExclusive) {
                fieldCharData = _.cloneDeep(this.catalogCharDataExclusiveCollection[firstAssetKey].charDatas[fieldName]);
            }
            else {
                fieldCharData = _.cloneDeep(this.catalogCharDataNonExclusiveCollection[firstAssetKey].charDatas[fieldName]);
            }

            this.bulkEditCharData = fieldCharData;
        }

        CancelBulkEditColumn() {
            this.bulkEditColumn = false;
        }

		SaveBulkEditColumn() {
			var relativeToRels: Models.ICharDataExtensionDataDateMathRel[] = [];

			this.bulkEditCharData.forEach(cd => {
				if (cd.ext != null) {
					cd.ext.dateMath.relationships.forEach(rel => {
						if (rel.relativeCatalogID) {
							relativeToRels.push(rel);
						}
					});
				}
			});

			var collection = this.bulkEditExclusive
				? this.catalogCharDataExclusiveCollection
				: this.catalogCharDataNonExclusiveCollection;

			for (var assetID in this.selectedAssets) {
				collection[assetID].charDatas[this.bulkEditField] = _.cloneDeep(this.bulkEditCharData);
			}

			if (relativeToRels.length > 0) {
				this.isCorrectingRelativeDateMath = true;
				var tagLabels: string[] = [];
				var tagLabelToCharId = [];

				relativeToRels.forEach(rel => {
					var charId = rel.relativeCatalogID;

					var relatedToCmd = _.find(this.firstCatalogItemCharDataCol.templateMetaData.characteristicMetaDatas,
						cmd => {
							return cmd.characteristicID === charId;
						});

					tagLabels.push(relatedToCmd.tagLabel);
					tagLabelToCharId[relatedToCmd.tagLabel] = relatedToCmd.characteristicID;
				});

				var recIds = Object.keys(this.selectedAssets).map(x => Number(x));
				var field = this.bulkEditField;
				this.dateCalcService.correctRelativeToDateMath(recIds, tagLabels)
					.then(data => {
						data.assetRecCharCorrections.forEach(correction => {
							collection[correction.assetId].charDatas[field].forEach(cd => {
								if (cd.ext != null) {
									var characteristicId = tagLabelToCharId[correction.tagLabel];
									var relToFix = _.find(cd.ext.dateMath.relationships,
										rel => {
											return rel.relativeCatalogID === characteristicId;
										});

									relToFix.parentRecCharID = correction.recCharId;
									relToFix.parentRecID = correction.assetId;
								}
							});
						});
						this.isCorrectingRelativeDateMath = false;
				});
			}

			this.bulkEditColumn = false;
		}

        GetCommonCmds() {
            // get all date chars from each catalog item
            var selectedAssetDateCMDs: Array<Array<Models.ICharacteristicMetaData>> = [];
            this.selectedCharDataCollections.forEach(cdc => {
                selectedAssetDateCMDs.push(cdc.templateMetaData.characteristicMetaDatas.filter(x => x.dataTypeID === 5));
            });

            if (selectedAssetDateCMDs.length === 0) return null;

            // get only common date chars between all catalog items (different templates might have different date chars?)
            var commonCMDs = selectedAssetDateCMDs[0].filter(cmd => {
                return _.all(selectedAssetDateCMDs, (cmdc: Array<Models.ICharacteristicMetaData>) => _.any(cmdc, (cmd2: Models.ICharacteristicMetaData) => cmd2.characteristicID === cmd.characteristicID));
            });

            this.commonCMDs = commonCMDs;
        }
        //--
    }
